import { NozzleType } from "@/types/common"
import { AutoLayout, SimiulatorEquipment, SimulatorNozzle } from "@/types/equipment"
import { memo, useContext, useMemo } from "react"
import styles from './styles/nozzle.module.less';
import classNames from "classnames"
import { LayoutEditorContext } from "./LayoutEditorContext"

export interface ImageNozzleProps {
  equipWidth: number
  equipHeight: number
  nozzle: SimulatorNozzle
}

export const DefaultNozzle = memo((props: ImageNozzleProps) => {
  const {nozzle, equipWidth, equipHeight} = props
  const {layout, nozzleId, selectedNozzle: onSelect} = useContext(LayoutEditorContext)
  const styleAttrs = useMemo(() => {
    let currentLayout = nozzle.customLayout || {}
    if (nozzleId === nozzle.id) {
      currentLayout = layout || {}
    }
    const { x = 0, y = 0 } = currentLayout as any
    return {
      left: `${x * equipWidth - 4}px`,
      top: `${y * equipHeight - 4}px`,
    }
  }, [nozzle, equipWidth, equipHeight, nozzleId, layout])
  return <div className={styles.defaultNozzle} style={styleAttrs} onClick={() => onSelect(nozzle)}></div>
})

export const ImageNozzle = (props: ImageNozzleProps) => {
  const {nozzle, equipWidth, equipHeight} = props
  const {layout, nozzleId, selectedNozzle: onSelect} = useContext(LayoutEditorContext)

  const styleAttrs = useMemo(() => {
    let currentLayout = nozzle.customLayout || {}
    if (nozzleId === nozzle.id) {
      currentLayout = layout || {}
    }
    const { width = 20, height = 20, x = 0, y = 0, angle = 0 } = currentLayout as any
    return {
      width: `${width}px`,
      height: `${height}px`,
      left: `${x * equipWidth}px`,
      top: `${y * equipHeight - height * 0.5}px`,
      rotate: `${angle % 360}deg`,
      transformOrigin: `left center`
    }
  }, [nozzle, equipWidth, equipHeight, nozzleId, layout])
  
  if (nozzle.type === NozzleType.FlowNozzle) {
    if (!nozzle.shape?.svg) return <DefaultNozzle {...props} />
    return <div
      onClick={() => onSelect(nozzle)}
      dangerouslySetInnerHTML={{ __html: nozzle.shape?.svg }}
      style={styleAttrs}
      className={classNames(styles.nozzleImage, 'absolute')}
    ></div>
  }

  return <div
    onClick={() => onSelect(nozzle)}
    className={styles.instNozzle}
    style={{ ...styleAttrs, width: undefined, height: undefined }}></div>
}